import React, { FC } from 'react';
import { alpha, Box, makeStyles, Typography } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(8, 5, 10),
    minHeight: 'auto',
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(6.5),
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: '100vh',
      paddingTop: theme.spacing(8),
    },
  },
  text: {
    maxWidth: 450,
    marginBottom: theme.spacing(8),
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(10),
    },
  },
  list: {
    padding: 0,
    margin: 0,
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    listStyleType: 'none',
    '&:not(:last-child) $line': {
      minHeight: 85,
      borderLeft: `1px dashed ${theme.palette.primary.main}`,
      width: 1,
      margin: theme.spacing(2, 'auto'),
      display: 'block',
      [theme.breakpoints.up('lg')]: {
        minHeight: 125,
      },
    },
  },
  indexNumber: {
    fontSize: 24,
    fontWeight: 700,
    width: 51,
    height: 51,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: alpha(theme.palette.primary.main, 0.2),
    color: theme.palette.primary.main,
    borderRadius: '50%',
  },
  title: { margin: theme.spacing(2, 0) },
  line: { display: 'none' },
  indexWrapper: { marginRight: theme.spacing(4) },
}));

const descriptionList: Array<{ title: string; text: string }> = [
  {
    title: 'Provide business details',
    text: 'Information collected here will provide valuable insight into your current electrical usage and the actual cost of your lighting.',
  },
  {
    title: 'Perform a lighting audit',
    text: "This is the process of identifying and counting all of the lights you're looking to upgrade. Once complete, we can provide proper retrofit recommendations.",
  },
  {
    title: 'Customize your retrofit',
    text: 'Choose the best retrofitting solutions for your existing lights.',
  },
  {
    title: 'Get the upgrade',
    text: 'Place an order to finish your project. If rebates are available, we will walk you through the process to make sure you receive the maximum available to you.',
  },
];

const DescriptionSection: FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h3">
        How it works
      </Typography>
      <Typography className={classes.text} variant="body2">
        You're just a few steps away from getting the perfect LED recommendations for your business.
        Just follow these simple instructions to get the most from your lighting upgrade.
      </Typography>
      <ul className={classes.list}>
        {descriptionList.map(({ title, text }, index) => (
          <li className={classes.listItem} key={index + 1}>
            <Box className={classes.indexWrapper}>
              <Typography component="span" className={classes.indexNumber}>
                {index + 1}
              </Typography>
              <Box className={classes.line} />
            </Box>
            <Box>
              <Typography variant="h4" className={classes.title}>
                {title}
              </Typography>
              <Box maxWidth={370}>
                <Typography variant="body2">{text}</Typography>
              </Box>
            </Box>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default DescriptionSection;
